<template>
  <div
    class="ag-header-group-cell-label ag-sticky-label mt-1"
    style="display: block"
  >
    <v-menu
      :close-on-content-click="false"
      v-bind="defaultVTooltipProps"
      max-height="20rem"
      open-on-hover
      offset-x
      nudge-top="20"
      role="none"
    >
      <template #activator="{ on }">
        <div
          :class="{ 'cursor-help': isDescriptionDifferent }"
          v-on="on"
        >
          <span
            class="ag-header-group-text"
            role="presentation"
            v-html="displayName"
          />
        </div>
      </template>

      <!-- <v-card v-if="isDescriptionDifferent">
        <v-card-text v-if="params?.sourceName || displayName">
          <span v-html="params?.sourceName || displayName" />
          <span v-html="description"></span>
        </v-card-text>
      </v-card> -->

      <v-card :flat="!isDescriptionDifferent">
        <v-card-text :class="{ 'p-1': !isDescriptionDifferent }">
          <!-- <span v-html="params?.sourceName" /> -->
          <div class="d-flex flex-column">
            <span>
              <span
                class="font-weight-bold"
                v-html="nameToShow"
              />
              <span v-if="unit">{{ ', ' + unit }}</span>
            </span>

            <span
              v-if="isDescriptionDifferent"
              v-html="description"
            />

            <span
              v-if="parentDescription"
              v-html="parentDescription"
              class="font-italic mt-2"
            />
          </div>
        </v-card-text>
      </v-card>
    </v-menu>

    <div v-if="unit">
      <v-menu
        offset-x
        :close-on-content-click="false"
        :disabled="!possibleConversions"
        role="none"
      >
        <template #activator="{ on }">
          <span
            v-on="on"
            class="ag-header-group-text text-monospace font-weight-lighter text-primary"
            :class="possibleConversions ? 'cursor-pointer text-primary ' : 'text-muted'"
            v-html="unit"
          />
        </template>

        <v-card v-if="possibleConversions?.length">
          <v-subheader
            class="py-2"
            style="height: auto"
          >
            Convert to
          </v-subheader>
          <v-list dense>
            <v-list-item
              v-for="(unit, index) in possibleConversions"
              :key="index"
              @click="updateFieldUnit(colId, unit)"
            >
              <v-list-item-title>
                <span v-html="unit" />
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-card>
      </v-menu>
    </div>
  </div>
</template>

<script>
import { defaultVTooltipProps } from '@/utils/defaultProps'
import { sortBy } from 'lodash-es'

export default {
  name: 'GroupHeaderRenderer',

  // props: {
  //   params: {
  //     type: Object,
  //     required: true,
  //   },
  // },

  data() {
    return {
      defaultVTooltipProps,
      colId: null,
      updateFieldUnit: null,
      // unit: null,
      displayName: null,
      sourceName: null,
      description: null,
      parentDescription: null,
      possibleConversions: null,
    }
  },
  computed: {
    nameToShow() {
      return this.sourceName || this.displayName || ''
    },

    isDescriptionDifferent() {
      return (this.description && this.nameToShow !== this.description) || !!this.parentDescription
    },

    unit() {
      return this.params?.unit
    },
  },

  beforeMount() {
    this.colId = this.params?.field
    // this.unit = this.params?.unit
    this.displayName = this.params?.displayName
    this.sourceName = this.params?.sourceName
    this.description = this.params?.description
    this.parentDescription = this.params?.parentDescription
    this.possibleConversions = this.params?.possibleConversions?.length
      ? sortBy(this.params?.possibleConversions)
      : null
    // Initialize switch states based on context (if available)
    this.updateFieldUnit = this?.params?.context?.headerRenderer?.updateFieldUnit || null
  },
}
</script>

<style scoped>
.ag-header-group-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
}

.cursor-help:hover {
  cursor: help;
}
</style>

<!-- style="writing-mode: vertical-rl" -->
